import { HttpApplication } from '../../../http';

export const createCommunication = (request: { subject: string; content: string; tin: string }) => {
  return HttpApplication.post<any>(`/Inbox/taxpayer`, request);
};
